export default __webpack_public_path__ + "static/media/graphics-03.4bad62cb.png";